import { Button, Stack, Typography } from '@mui/material';

import Modal from 'components/v2/modal/Modal';
import { TASKS_MODAL_ID } from 'constants/ui/modal';
import { MODAL_WIDTH } from 'constants/ui/style';
import TaskModalTitle from 'components/v2/shared/TaskModalTitle';

import { useAITextOverviewTaskModal } from 'hooks/services/useAITextOverviewTaskModal';

const AITextOverviewTaskModal = () => {
  const { t, reference, isLoading, isFetched, descriptionMessage, onOpenAIText, isModalOpen, toggleModal } =
    useAITextOverviewTaskModal();

  return (
    <Modal
      isOpen={isModalOpen(TASKS_MODAL_ID.AITextOverview)}
      toggleModal={() => toggleModal(TASKS_MODAL_ID.AITextOverview)}
      modalTitle={<TaskModalTitle title={t('modals.aiText.title')} caseId={reference ?? ''} />}
      width={MODAL_WIDTH.md}
      hideFooter
    >
      <Stack gap={2}>
        {!isLoading && isFetched && <Typography variant="subtitle1">{descriptionMessage}</Typography>}
        <Button
          variant={isLoading ? 'outlined' : 'contained'}
          sx={{ minWidth: 'fit-content' }}
          loading={isLoading}
          onClick={onOpenAIText}
          disabled={isLoading}
        >
          {t('common.actions.openAIText')}
        </Button>
      </Stack>
    </Modal>
  );
};
export default AITextOverviewTaskModal;
